import { useState, useEffect } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import "../../styles/components/maintenanceBanner.scss";
import translations from "../../translations/landing.json";

import CloseIcon from "../../assets/common/close-icon.svg";

const MaintenanceBanner = (props) => {
	props.addTranslation(translations);
	const [showMaintenanceBanner, setShowMaintenanceBanner] = useState(false);

	useEffect(() => {
		// Show maintenance banner
		const now = new Date();
		const maintenanceStartDate = new Date("2023-10-29T13:00:00");
		const maintenanceEndDate = new Date("2023-10-29T14:00:00");
		if (maintenanceEndDate > now && now > maintenanceStartDate)
			setShowMaintenanceBanner(true);
	}, []);

	return showMaintenanceBanner ? (
		<div id="maintenance-banner" className="flex-row jc-c">
			<div className="banner-inner flex-row jc-sb">
				<span>
					<Translate id="maintenance" />
				</span>
				<img
					src={CloseIcon}
					className="close-icon"
					alt="Close Banner"
					width="15"
					height="15"
					onClick={() => setShowMaintenanceBanner(false)}
				/>
			</div>
		</div>
	) : null;
};

export default withLocalize(MaintenanceBanner);
